import { SearchDriverOptions } from '@elastic/search-ui';

import { searchConnector } from './search-connector';

export const searchDriver = (node_locale: string): SearchDriverOptions => {
  const config: SearchDriverOptions = {
    apiConnector: searchConnector(),
    hasA11yNotifications: true,
    autocompleteQuery: {
      results: {
        resultsPerPage: 8,
        result_fields: {
          search_title: { raw: {} },
          page_category: { raw: {} },
          url_path: { raw: {} },
        },
        search_fields: {
          search_title: { weight: 10 },
          meta_description: { weight: 2 },
          headings: { weight: 8 },
          body_content: {},
          category: { weight: 6 },
        },

        filters: [{ field: 'node_locale', values: [node_locale], type: 'all' }],
      },
    },
    searchQuery: {
      resultsPerPage: 24,
      result_fields: {
        search_title: { raw: {} },
        page_category: { raw: {} },
        url_path: { raw: {} },
        page_image: { raw: {} },
      },
      search_fields: {
        search_title: { weight: 9 },
        meta_description: { weight: 3 },
        headings: { weight: 8 },
        body_content: { weight: 2 },
        category: { weight: 6 },
      },
      filters: [{ field: 'node_locale', values: [node_locale], type: 'all' }],
      disjunctiveFacets: ['page_category'],
      facets: {
        page_category: {
          type: 'value',
          size: 100,
        },
      },
    },
  };
  return config;
};
